export default "__VITE_ASSET__DmzHmn8g__"